import {useNavigate} from "react-router-dom";
import {useNotification} from "../../context/NotificationContext";
import WithNavTemplate from "../../components/template/WithNavTemplate";
import MyProfile from "../../components/myProfile/MyProfile";
import Navigation from "../../components/navigation/Navigation";
import Spinner from "../../components/spinner/Spinner";
import ReactionModal from "../../components/reactionModal/ReactionModal";
import {useCommentLikeModal} from "../../context/CommentLikeModalContext";
import {useModal} from "../../context/ModalContext";
import {useCommentDeleteModal} from "../../context/CommentDeleteModalContext";
import Modal from "../../components/modal/Modal";
import CommentDeleteModal from "../../components/commentDeleteModal/CommentDeleteModal";

const ProfilePage = () => {
  const {
    socketState,
    setNotificationModal,
    setSelectedPostNotification,
    setSelectedNotificationId,
  } = useNotification();
  const navigate = useNavigate();
  const navigationOnClick = () => {
    navigate("/");
  };
  const {
    modalOpen,
    modalTitle,
    closeModal,
    confirmHandler,
    isLoading: modalLoading,
  } = useModal();
  const {isOpen: commentLikeModalIsOpen} = useCommentLikeModal();
  const {isOpen: commentDeleteModalIsOpen} = useCommentDeleteModal();

  if (!socketState) {
    return (
      <>
        <Navigation />
        <div className="inside-page-container-blk">
          <div
            className="main-container-blk"
            style={{
              position: "relative",
              height: "100vh",
              paddingTop: "200px",
            }}>
            <Spinner alignSpin="center-spinner" variant="large-spinner" />
          </div>
        </div>
      </>
    );
  }

  return (
    <WithNavTemplate
      socket={!socketState ? null : socketState}
      setNotificationModal={setNotificationModal}
      setSelectedPostNotification={setSelectedPostNotification}
      setSelectedNotificationId={setSelectedNotificationId}>
      {commentLikeModalIsOpen ? <ReactionModal /> : null}
      {commentDeleteModalIsOpen ? <CommentDeleteModal /> : null}
      <Modal
        title={modalTitle}
        modalOpen={modalOpen}
        setDeleteModal={closeModal}
        onSubmitHandler={confirmHandler}
        isLoading={modalLoading}
      />
      <div className="inside-page-container-blk profile-main-container">
        <div className="main-container-blk">
          <div className="page-title-blk">
            <i
              onClick={navigationOnClick}
              className="fa-solid fa-arrow-left arrow-back-page"></i>
            <h1>My Profile</h1>
          </div>
          <MyProfile />
        </div>
      </div>
    </WithNavTemplate>
  );
};

export default ProfilePage;
